export const COLORS = {
  iStaffGreen: "#8FC002",
  iStaffGreenDarker: "#8FC002",
  errorRed: "#FF0000",
  successGreen: "#065c1f",
  pendingYellow: "#f0ad4e",
  textInputGrey: "#05375a",
  lighterTextInputGrey: "#888888",
  WHITE: "#fff",
  BLACK: "#000",
  borderGrey: "#dfdfdf",
  warningYellow: "ffc107",
};
